/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import YouTube from 'react-youtube';

/* Internal Imports */
/* Components */
import LiteYouTubeEmbed from '@eternal/Components/Embeds/YoutubeEmbed';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import { getEmbedUrl } from '@eternal/Components/Utility/utils';

/* Services */
import { isInViewport } from '@eternal/Components/Ui/SharedService';

/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param {object} sectionContent - Data for Section
 * @param margin
 * @param width
 * @param pxBase
 * @returns {ReactElement} MediaEmbed component
 */
const MediaEmbedV2 = ({
  sectionContent,
  margin,
  width,
  lang,
  hideBg,
  ...props
}) => {
  const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});
  const isMobile = useMediaQuery({ maxWidth: 767 });
  useEffect(() => {
    setOpts({
      height: isMobile ? '200px' : '420px',
      //height: '315',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window, isMobile]);

  useEffect(() => {
    if (props.autoplay) {
      window.addEventListener('scroll', listenToScroll);
    }
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const scrollDiv = document.getElementById(props['sectionId']);
    const inViewPort = isInViewport(scrollDiv);
    if (!vidVis && inViewPort) {
      setVidVis(true);
    }
  };

  const onReady = event => {
    event.target.playVideo();
  };

  if (sectionContent?.thumbnailDesktopImage?.url && !hideBg) {
    return (
      <MidContainer w={width || '696px'} h="100%">
        <Box
          backgroundImage={
            !vidVis ? sectionContent?.thumbnailDesktopImage?.url : 'none'
          }
          bgSize="contain"
          backgroundSize="100%"
          // backgroundColor="#000"
          backgroundRepeat="no-repeat"
          backgroundPosition={
            sectionContent.id === '170001416' ? 'left' : 'center'
          }
          width="100%"
          position="relative"
          display="flex"
          // boxShadow="0px 31px 20px -13px rgba(0,0,0,0.47)"
          justifyContent="center"
          alignItems="center"
          flexDir="column"
          cursor="pointer"
          // onClick={e => setVidVis(!vidVis)}

          top="0px"
          borderRadius={props.round || { base: '6px', md: 'none' }}
          id="embed-vid"
          {...props}
        >
          {vidVis && (
            <Box maxW="100%" w="full" h="100%">
              <YouTube
                videoId={getEmbedUrl(sectionContent?.video?.url)}
                onReady={onReady}
                opts={opts}
                loading="eager"
              />{' '}
            </Box>
          )}
        </Box>
      </MidContainer>
    );
  }

  return (
    <MidContainer w={width || '696px'} py="0" h="100%">
      <Box
        // backgroundImage={sectionContent?.video?.thumbnailUrl}
        // backgroundSize="cover"
        // backgroundColor="#000"
        // backgroundRepeat="no-repeat"
        // backgroundPosition="center"
        width="100%"
        position="relative"
        display="flex"
        justifyContent="center"
        height="100%"
        alignItems="center"
        flexDir="column"
        cursor="pointer"
        onClick={() => setVidVis(!vidVis)}
        overflow="hidden"
        id="embed-vid"
        {...props}
      >
        <Box maxW="100%" w="100%" h="100%">
          <LiteYouTubeEmbed
            id={getEmbedUrl(sectionContent?.video?.url)}
            embedUrl={getEmbedUrl(sectionContent?.video?.url)}
            cookie
          />
        </Box>
      </Box>
    </MidContainer>
  );
};

export default MediaEmbedV2;
